interface FieldsBinderOptions {
    $parent: JQuery;
    controller: string;
    addUrl?: string;
    editUrl?: string;
    isFormData?: boolean;

    // Optional overrides
    getDetails?: (event: any) => any;
    addDetails?: (event: any) => any;
    editDetails?: (event: any) => any;
    bindAdditionalButtons?: () => void;
}

class FieldsBinder {
    //#region FieldsBinder Properties
    $parent: JQuery;
    controller!: string;

    addUrl: string;
    editUrl: string;
    isFormData: boolean;
    //#endregion FieldsBinder Properties

    //#region Optional override methods (from options)
    bindAdditionalButtons!: () => void;
    //#endregion Optional override methods (from options)

    constructor(options: FieldsBinderOptions) {
        this.$parent = options.$parent;

        // Set Defaults for fall back.
        this.addUrl = 'Add';
        this.editUrl = 'Edit';
        this.isFormData = false;

        // Default no-op implementations
        this.bindAdditionalButtons = () => { };

        // Copy all options into instance (same behavior as before)
        Object.keys(options).forEach(key => {
            const value = (options as any)[key];
            if (value !== undefined) {
                (this as any)[key] = value;
            }
        });

        // Explicit property overrides for required properties
        this.controller = options.controller;
    }

    bindSaveButtons(): void {
        this.$parent.find('div[name="btnsCancelAdd"] button[name="Save"]').on('click', (event: any) => this.saveDetails(event, this.addUrl));
        this.$parent.find('div[name="btnsCancelSave"] button[name="Save"]').on('click', (event: any) => this.saveDetails(event, this.editUrl));

        this.bindAdditionalButtons();
    }

    saveDetails(event: any, controllerMethod: string): void {
        const ajaxOptions: JQueryAjaxSettings = {
            type: "POST",
            url: `${window.appRoot}${this.controller}/${controllerMethod}`,
            data: this.getDetails(event),
            success: (data: AjaxSaveDetailsResult) => {
                if (data.Success) {
                    window.location.href = data.RedirectUrl!;
                    return;
                }

                if (data.SaveMessageView) {
                    appendMessagePartial(this.$parent, data.SaveMessageView);
                    $('html, body').animate({ scrollTop: 0 }, 100);
                }
            },
            error: (_xhr, _status, error) => {
                console.log(error);
                if (_xhr.status == 403) {
                    setMessageError(this.$parent, "Access Denied");
                } else {
                    setMessageError(this.$parent, error);
                }
            }
        };

        if (this.isFormData) {
            ajaxOptions.contentType = false;
            ajaxOptions.processData = false;
        }

        $.ajax(ajaxOptions);
    }

    getDetails(event: any): any {
        return this.getDefaultDetails(event);
    }

    getDefaultDetails(event: any): any {
        let model;

        if (this.isFormData) {
            model = GetFormDataUnMasked(this.$parent.findInGrid('form'));
        } else {
            model = this.$parent.findInGrid('form :input').not('[name^="inline"] :input').serialize();
        }

        return model;
    }
}